import { Datepicker } from 'vanillajs-datepicker';
import de from 'vanillajs-datepicker/locales/de';
import $ from 'jquery';
import initTextSwitch from './_textSwitch';
import customSelect from 'custom-select';
import dateInputs from './_date-value-check';

Object.assign(Datepicker.locales, de);

let datepicker;


function init() {
  let resizeTimers = {};

  const formEl = document.querySelector('.medatixx-form');

  if (formEl) {
    const myModal = document.getElementById('medatixx');
    myModal.addEventListener('shown.bs.modal', () => {
      let textSwitchBtn = document.querySelector('.text-switch__button');
      if (textSwitchBtn) {
        textSwitchBtn.click();
      }
    })

    $('.medatixx-form--appointment .btn-primary').click(function (e) {
      e.preventDefault();

      let formData = new FormData(formEl);

      $.ajax({
        url: formEl.getAttribute('action'),
        data: formData,
        method: formEl.getAttribute('method'),
        processData: false,
        contentType: false,
        accept: 'application/json',
        success: function (result) {
          const jsonObject = JSON.parse(result);
          const enabledDates = jsonObject.enabled_dates;
          document.querySelector('.medatixx-form--appointment').classList.add('d-none');
          document.querySelector('#medatixx .form__results').classList.remove('d-none');

          document.querySelector('.form__results').innerHTML = jsonObject.result_markup;

          document.querySelector('.kirinus-appointment input:first-child').checked = true;
          document.querySelector('.kirinus-practitioner input:first-child').checked = true;

          document.querySelector('#medatixx .form__steps').querySelector('[data-step]:last-child').classList.add('last-step');

          dataPicker(enabledDates);
          appointmentNavigator(datepicker);
          formSelect();
          dateInputs.init();

          formSteps();

          document.querySelector('.medatixx-form--appointment .btn-primary').classList.remove('disabled');

          $('.medatixx-form_2').submit(function (e) {
            e.preventDefault();
            let formEl = document.querySelector('.medatixx-form_2');
            let formData = new FormData(formEl);

            $.ajax({
              url: formEl.getAttribute('action'),
              data: formData,
              method: formEl.getAttribute('method'),
              processData: false,
              contentType: false,
              accept: 'application/json',
              success: function (result) {
                const jsonObject = JSON.parse(result);
                const title = jsonObject.title;
                const text = jsonObject.text;
                document.querySelector('.form__results').classList.add('form__results--success')
                document.querySelector('.medatixx__title').innerHTML = title;
                document.querySelector('.form__results').innerHTML = `<p>${text}</p><button data-bs-toggle="modal" data-bs-target="#medatixx" class="btn btn-primary">Schließen</button>`;
                document.querySelector('.form__footer').style.marginTop = '0';
                document.querySelector('.form__footer .contact-form__required').parentElement.classList.add('d-none');
              }
            });
          })
        }
      });
    })
  }

  function formSteps() {
    let stepControls = document.querySelectorAll('.medatixx .form__controls [data-step]');


    document.querySelector('.medatixx [data-step="next"]').addEventListener('click', function (e) {
      if (this.getAttribute('type') !== 'submit') {
        e.preventDefault();
      }

      const activeElement = document.querySelector(`.form__results [data-step].active`);
      let nextStepBtn = document.querySelector('.form__results .btn--next');
      let prevStepBtn = document.querySelector('.form__results .btn--prev');
      let medatixxFormAppointment = document.querySelector('.medatixx-form--appointment');

      if (activeElement.nextElementSibling !== null) {
        activeElement.nextElementSibling.classList.add('active');
        activeElement.classList.remove('active');
        prevStepBtn.classList.remove('d-none');

        initTextSwitch();

        const activeElement2 = document.querySelector(`.form__results [data-step].active`);
        if (activeElement2.nextElementSibling === null) {
          nextStepBtn.innerText = 'Termin anfragen';
          nextStepBtn.setAttribute('type', 'submit');
          medatixxFormAppointment.classList.add('d-none');
        }
      }
    });

    document.querySelector('.medatixx [data-step="prev"]').addEventListener('click', function (e) {
      e.preventDefault();

      const activeElement = document.querySelector(`.form__results [data-step].active`);
      let nextStepBtn = document.querySelector('.form__results .btn--next');
      let prevStepBtn = document.querySelector('.form__results .btn--prev');
      let medatixxFormAppointment = document.querySelector('.medatixx-form--appointment');

      if (activeElement.previousElementSibling !== null) {
        activeElement.previousElementSibling.classList.add('active');
        activeElement.classList.remove('active');
      }

      if (activeElement.previousElementSibling !== null) {
        activeElement.previousElementSibling.classList.add('active');
        activeElement.classList.remove('active');
        prevStepBtn.classList.remove('d-none');
        nextStepBtn.innerText = 'Weiter';
        nextStepBtn.setAttribute('type', 'button');
        medatixxFormAppointment.classList.add('d-none');
      } else {
        medatixxFormAppointment.classList.remove('d-none');
        document.querySelector('#medatixx .form__results').classList.add('d-none');
      }

      initTextSwitch();
    });

    for(let item of stepControls) {
      item.addEventListener('click', function (e) {

        if (this.getAttribute('type') !== 'submit') {
          e.preventDefault();
        }

        let getSelectedPractitioner = document.querySelector('.kirinus-appointment input:checked').value;
        let medatixxTitle = document.querySelector('.medatixx__title');
        const getTime = getSelectedPractitioner.split(" - ");
        const getDate = document.querySelector('.meeting-datepicker').value;

        if (document.querySelector('.form__results [data-step="1"]').classList.contains('active')) {
          let dateTitle = document.querySelector('.medatixx__title-date');
          if (dateTitle) {
            dateTitle.remove();
          }
        } else if (!document.querySelector('.form__results [data-step].active').classList.contains('last-step')) {
          medatixxTitle.innerHTML = `${medatixxTitle.innerText} <span class="medatixx__title-date">für den <span class="fw-bold">${getDate}</span> um <span class="fw-bold">${getTime[0]} Uhr</span> <span data-step="${document.querySelector('.form__results [data-step].active').getAttribute("data-step") - 1}" class="fa fa-edit" style="cursor: pointer"></span>`

          document.querySelector('.fa-edit').addEventListener('click', function () {
            document.querySelector('.form__controls .btn--prev').click();
          });
        }

        document.querySelector('#medatixx').scrollTo({top: 0, behavior: 'smooth'});
      });
    }
  }

  function appointmentNavigator(datepicker) {
    let navigateAppointment = document.querySelectorAll('.kirinus-navigate-appointment button');
    let navigateAppointmentPrev = document.querySelector('.kirinus-navigate-appointment .prev');
    let navigateAppointmentNext = document.querySelector('.kirinus-navigate-appointment .next');

    for (let item of navigateAppointment) {
      item.addEventListener('click', function () {
        let activeElement = document.querySelector('.kirinus-appointment .active');

        if (this.classList.contains('prev')) {
          let previousElement = activeElement.previousElementSibling;

          if (previousElement !== null) {
            activeElement.classList.remove('active');
            previousElement.classList.add('active');

            navigateAppointmentPrev.disabled = document.querySelector('.kirinus-appointment .active').previousElementSibling === null;
            navigateAppointmentNext.disabled = false;
          } else {
            navigateAppointmentNext.disabled = false;
            navigateAppointmentPrev.disabled = true;
          }
        } else {
          let nextElement = activeElement.nextElementSibling;

          if (nextElement !== null) {
            activeElement.classList.remove('active');
            nextElement.classList.add('active');

            navigateAppointmentNext.disabled = document.querySelector('.kirinus-appointment .active').nextElementSibling === null;
            navigateAppointmentPrev.disabled = false;
          } else {
            navigateAppointmentPrev.disabled = false;
            navigateAppointmentNext.disabled = true;
          }
        }

        item.parentElement.querySelector('label').innerText = `Termine am ${formatDate(document.querySelector('.kirinus-appointment .active').getAttribute('data-date'))}.`;
        datepicker.setDate(new Date(document.querySelector('.kirinus-appointment .active').getAttribute('data-date')));
      });
    }
  }

  function dataPicker(enabledDates) {
    let activeDates = [];
    for(let item of enabledDates) {
      activeDates.push(new Date(item.year, item.month, item.day),)
    }

    datepicker = new Datepicker(document.querySelector('.medatixx .meeting-datepicker'), {
      buttonClass: 'btn',
      autohide: false,
      format: 'dd.mm.yyyy',
      orientation: 'auto middle',
      language: 'de',

      beforeShowDay: date => {
        const currentDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        const isFirstDate = currentDate.getTime() === activeDates[0].getTime();

        if (isFirstDate) {
          console.log('Erstes Datum:', currentDate);
        }

        const isActive = activeDates.some(activeDate =>
          currentDate.getTime() === activeDate.getTime()
        );

        return {
          enabled: isActive,
          classes: isFirstDate ? 'active selected' : (isActive ? 'active' : 'disabled')
        };
      }
    });
    document.querySelector('.datepicker-cell.selected').click();

    let datepickerPrevBtn = document.querySelectorAll('.datepicker-controls .prev-btn');
    let datepickerNextBtn = document.querySelectorAll('.datepicker-controls .next-btn');

    for (let item of datepickerPrevBtn) {
      item.innerHTML = '<span class="fa fa-angle-left">';
    }

    for (let item of datepickerNextBtn) {
      item.innerHTML = '<span class="fa fa-angle-right">';
    }

    document.querySelector('.medatixx .meeting-datepicker').addEventListener('changeDate', function(event) {
      const selectedDate = event.detail.date;
      const formattedDate = selectedDate.toLocaleDateString('de-DE');
      const inputField = document.querySelector('.meeting-datepicker');
      inputField.value = formattedDate;

      const parts = formattedDate.split('.');
      if (parts.length === 3) {
        const day = parts[0].padStart(2, '0');
        const month = parts[1].padStart(2, '0');
        const year = parts[2];

        document.querySelector(`.kirinus-appointment [data-date].active`).classList.remove('active');
        document.querySelector(`.kirinus-appointment [data-date="${year}-${month}-${day}"]`).classList.add('active');
        document.querySelector('.kirinus-navigate-appointment label').innerText = `Termine am ${day}.${month}.`;

        let navigateAppointmentPrev = document.querySelector('.kirinus-navigate-appointment .prev');
        let navigateAppointmentNext = document.querySelector('.kirinus-navigate-appointment .next');

        navigateAppointmentPrev.disabled = document.querySelector('.kirinus-appointment .active').previousElementSibling === null;
        navigateAppointmentNext.disabled = document.querySelector('.kirinus-appointment .active').nextElementSibling === null;

      }
    });

    const customFooter = document.createElement('div');
    customFooter.classList.add('datepicker-info');
    customFooter.innerHTML = '<span></span> Tage mit freien Terminen';

    document.querySelector('.datepicker-footer').appendChild(customFooter);

    datepicker.show();
  }

  function formatDate(inputDate) {
    const dateObject = new Date(inputDate);
    const day = String(dateObject.getDate()).padStart(2, '0');
    const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Monate beginnen bei 0
    return `${day}.${month}`;
  }

  function formSelect() {
    const elements = [...document.querySelectorAll('#medatixx .form__steps .form-select')];
    for (const element of elements) {
      const isInvalid = element.classList.contains('is-invalid');
      const isValid = element.classList.contains('is-valid');

      const createdFields = customSelect(element, {
        openerClass: 'custom-select-opener form-select',
      });

      /**
       * @type {HTMLElement}
       */
      const { opener, container } = createdFields[0];

      if (isInvalid) {
        container.classList.add('is-invalid');
        opener.classList.add('is-invalid');
      }

      if (isValid) {
        container.classList.add('is-valid');
        opener.classList.add('is-valid');
      }
    }

    const transition = document.querySelectorAll('.custom-select-panel');
    for (const element of transition) {
      element.ontransitionstart = () => {
        const selectedOption = element.closest('.custom-select-container').querySelector('.custom-select-opener span');
        if (element.closest('.custom-select-container').querySelector('select').value === '') {
          selectedOption.classList.remove('form-select__selected');
        } else {
          selectedOption.classList.add('form-select__selected');
        }

        element.parentNode.classList.add('custom-select-container--is-open');
      };

      element.ontransitionend = () => {
        if (!element.parentNode.classList.contains('is-open')) {
          element.parentNode.classList.remove('custom-select-container--is-open');
        }
      };
    }
  }

  const targetDiv = document.querySelectorAll('.modal--medatixx-iframe iframe');

  if (targetDiv) {
    for(let item of targetDiv) {
      let options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5
      };

      let observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (item.parentElement.querySelector('.cmppreviewroot')) {
              item.parentElement.querySelector('.cmppreviewroot').style.pointerEvents = 'none';
            }
          } else {
            if (item.parentElement.querySelector('.cmppreviewroot')) {
              item.parentElement.querySelector('.cmppreviewroot').style.pointerEvents = 'auto';
            }
          }
        });
      }, options);

      observer.observe(item);
    }
  }

  function updateBodyClass() {
    let modals = document.querySelectorAll('.modal--medatixx-iframe');

    if (modals) {
      modals.forEach((modal) => {
        modal.classList.add('modal--medatixx-iframe-is-resize');

        // Verwende ein separates Timer-Objekt für jedes Modal
        clearTimeout(resizeTimers[modal]);

        resizeTimers[modal] = setTimeout(function () {
          for(let item of modals) {
            item.classList.remove('modal--medatixx-iframe-is-resize');
          }
        }, 500);
      });
    }
  }

  window.addEventListener('resize', function() {
    updateBodyClass();
  });
}

export default {
  init
}


